import { QueryIntent } from '../constants';

export function getFrontendQueryIntent(
	query: string,
): { queryIntent: QueryIntent; transformedQuery: string } | undefined {
	const lowercaseQuery = query.toLowerCase();

	if (/\w+-\d+/.test(lowercaseQuery)) {
		return {
			queryIntent: QueryIntent.JIRA_ISSUE,
			transformedQuery: query,
		};
	}

	if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) {
		return {
			queryIntent: QueryIntent.AGENT,
			transformedQuery: query.replace(' agent', '').replace(' Agent', ''),
		};
	}
}
